/**
 * Navigation event utilities for web
 * Dispatches custom events when navigation occurs
 */

let isPatched = false

export function setupNavigationEvents() {
  if (typeof window === 'undefined' || isPatched) {
    return
  }

  const originalPushState = window.history.pushState
  const originalReplaceState = window.history.replaceState

  window.history.pushState = function (...args) {
    originalPushState.apply(this, args)
    window.dispatchEvent(new Event('navigation-changed'))
  }

  window.history.replaceState = function (...args) {
    originalReplaceState.apply(this, args)
    window.dispatchEvent(new Event('navigation-changed'))
  }

  isPatched = true
}
